"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loading = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../../shared/core");
var IconHeader_1 = require("../../../../../../../shared/core/components/IconHeader/IconHeader");
var StyledContentGrid_styled_1 = require("../../../../../components/StyledContentGrid.styled");
var Loading_styled_1 = require("./Loading.styled");
var Loading = function () {
    var _a = (0, core_1.useComponents)(), Card = _a.Card, Margin = _a.Margin, SkeletonCTA = _a.SkeletonCTA, ContentGrid = _a.ContentGrid, Skeleton = _a.Skeleton;
    return (react_1.default.createElement(Card, { "data-testid": "billing-loading" },
        react_1.default.createElement(Margin, { bottom: [4, 8] },
            react_1.default.createElement(IconHeader_1.SkeletonIconHeader, null)),
        react_1.default.createElement(StyledContentGrid_styled_1.StyledContentGrid, { as: ContentGrid, size: "30rem" },
            react_1.default.createElement(StyledContentGrid_styled_1.StyledContentGrid, { as: ContentGrid, size: "14rem" },
                react_1.default.createElement(Loading_styled_1.LoadingSkeleton, { as: Skeleton }),
                react_1.default.createElement(Loading_styled_1.LoadingSkeleton, { as: Skeleton })),
            react_1.default.createElement(StyledContentGrid_styled_1.StyledContentGrid, { as: ContentGrid, size: "14rem" },
                react_1.default.createElement(Loading_styled_1.LoadingSkeleton, { as: Skeleton }),
                react_1.default.createElement(Loading_styled_1.LoadingSkeleton, { as: Skeleton }))),
        react_1.default.createElement(SkeletonCTA, null)));
};
exports.Loading = Loading;
